import { render, staticRenderFns } from "./ArticleRelated.vue?vue&type=template&id=364816de&"
import script from "./ArticleRelated.vue?vue&type=script&lang=js&"
export * from "./ArticleRelated.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRelated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports